var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalloansyeargrowth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "finance and payment/outline/profit 02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 923",
    d: "M4 12C4 10.8954 4.89543 10 6 10H15C16.1046 10 17 10.8954 17 12V12C17 13.1046 16.1046 14 15 14H6C4.89543 14 4 13.1046 4 12V12Z",
    stroke: "#79CD49",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 18C12 20.2091 13.7909 22 16 22C18.2091 22 20 20.2091 20 18C20 15.7909 18.2091 14 16 14C15.8007 14 15.6047 14.0146 15.4132 14.0427M12 18C12 15.9902 13.4823 14.3266 15.4132 14.0427M12 18H6C4.89543 18 4 17.1046 4 16C4 14.8954 4.89543 14 6 14H15C15.1417 14 15.2799 14.0147 15.4132 14.0427",
    stroke: "#79CD49",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14 3.58579L12.7071 2.29289C12.3166 1.90237 11.6834 1.90237 11.2929 2.29289L10 3.58579M12 7L12 2.58579",
    stroke: "#79CD49",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalloansyeargrowth);
export default __webpack_public_path__ + "static/media/totalloansyeargrowth.cad06a17ec2ebdc220ff10cc3e4389ed.svg";
export { ForwardRef as ReactComponent };